import React from "react";

const StatusBadge = ({ status = "empty", label, tokens, size = "sm" }) => {
  const map = {
    healthy: {
      dot: tokens.healthy,
      bg: tokens.healthyBg,
      border: tokens.healthyBorder,
      text: tokens.healthyText,
      label: label || "Saudável"
    },
    watch: {
      dot: tokens.watch,
      bg: tokens.watchBg,
      border: tokens.watchBorder,
      text: tokens.watchText,
      label: label || "Atenção"
    },
    breach: {
      dot: tokens.breach,
      bg: tokens.breachBg,
      border: tokens.breachBorder,
      text: tokens.breachText,
      label: label || "Crítico"
    },
    empty: {
      dot: tokens.textMuted,
      bg: "transparent",
      border: tokens.cardBorder,
      text: tokens.textMuted,
      label: label || "Sem medição"
    }
  };
  const cfg = map[status] || map.empty;
  const padding = size === "sm" ? "2px 8px" : "4px 10px";
  const fontSize = size === "sm" ? 11 : 12;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding,
        borderRadius: 999,
        background: cfg.bg,
        border: "1px solid " + cfg.border,
        fontSize,
        fontWeight: 600,
        color: cfg.text,
        letterSpacing: "0.02em",
        whiteSpace: "nowrap"
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: cfg.dot,
          boxShadow: status !== "empty" ? "0 0 0 3px " + cfg.bg : "none",
          flexShrink: 0
        }}
      />
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
